"use client";

import { usePathname } from "next/navigation";
import posthog from "posthog-js";
import { useEffect } from "react";

const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;

export function PostHogPageViews() {
  const pathname = usePathname();

  useEffect(() => {
    if (!POSTHOG_KEY) return;

    if (typeof window === "undefined") return;

    const query = window.location.search;
    const currentUrl = query ? `${pathname}${query}` : pathname;

    posthog.capture("$pageview", { $current_url: currentUrl });
  }, [pathname]);

  return null;
}
